import { useSentry } from '@/hooks/sentry'
import { useEffect, useState } from 'react'

import { Button } from '@/components/button'
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/dialog'

interface Props {
    sendSentryError?: boolean
}

export const UnexpectedDataStateError = ({ sendSentryError = true }: Props) => {
    const [open, setOpen] = useState(true)
    const sentry = useSentry()
    useEffect(() => {
        // Sent that this error has occurred to Sentry so we can monitor it
        if (sendSentryError) {
            sentry.captureEvent({
                message: 'UnexpectedDataStateError',
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Something went wrong</DialogTitle>
                </DialogHeader>
                <p>
                    Sorry, it looks like we've hit an error.
                    <br />
                    We've logged this error and our support team will look into it.
                </p>
                <p>Please refresh the page and try again.</p>
                <DialogFooter>
                    <DialogClose asChild>
                        <Button type="button" variant="outline">
                            Close
                        </Button>
                    </DialogClose>
                    <Button type="submit" onClick={() => window.location.reload()}>
                        Refresh page
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
